<template>
  <div class="container" style="padding-top: 5rem">
    <div class="account-box">
      <div class="account-wrapper">
        <div class="alert alert-info text-justify">
          Password Requirement: <br />
          Must be minimum of 6 characters with combination of upper and lower
          case letters, numbers, and non-alphanumeric symbols
        </div>
        <form @submit.prevent="resetPassword">
          <p class="text-danger text-center" v-if="errorMessage">
            {{ errorMessage }}
          </p>
          <div class="form-group">
            <label>New Password</label>
            <input
              class="form-control"
              type="password"
              v-model="password"
              maxlength="50"
              required
              autocomplete="off"
            />
          </div>
          <div class="form-group">
            <label>Confirm New Password</label>
            <input
              class="form-control"
              type="password"
              v-model="confirmPassword"
              maxlength="50"
              required
              autocomplete="off"
            />
          </div>
          <div class="form-group text-center">
            <button class="btn btn-primary account-btn" type="submit">
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      errorMessage: "",
      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    resetPassword() {
      this.errorMessage = "";
      if (this.password != this.confirmPassword) {
        this.errorMessage =
          "Confirm New Password and New Password do not match";
        return;
      }
      this.$store.state.isLoading = true;
      API.schoolUser
        .resetPassword({
          Token: this.$route.params.token,
          NewPassword: this.password,
        })
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.$swal(response.data.message, {
              icon: "success",
            });
            this.$router.replace({ name: "schoolUserLogin" });
          } else {
            this.errorMessage = response.data.message;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    API.schoolUser
      .verifyResetPasswordLink({
        Token: to.params.token,
      })
      .then((response) => {
        if (!response.data.success) {
          return next({ name: "schoolUserLogin" });
        } else {
          return next();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style scoped>
.container {
  background: url("/static/bg-image.jpg") no-repeat center fixed;
  background-size: cover;
  -webkit-background-size: cover;
  max-width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/ResetPassword.vue